// @flow
import { DynamicPage } from 'Views/dynamic-page/DynamicPage.jsx';
export default DynamicPage;
